import React, { useContext } from 'react';
import { Select } from '@chakra-ui/react';
import { getPreferredUnit } from '../utils/helpers';
import { PreferredUnitsContext } from './contexts/PreferredUnitsContext';
import { parameterPreferredUnits, UNIT_MAPPINGS, categories } from '../utils/constants';

const ParameterSelect = (props) => {
    const { parameters, selectedParameter, setSelectedParameter } = props;

    const [preferredUnitSystem] = useContext(PreferredUnitsContext);

    const getDropdownParamUnits = (parameter) => {
        const preferredUnit = getPreferredUnit(parameter?.standardName, parameter?.unit, preferredUnitSystem);

        if (UNIT_MAPPINGS.hasOwnProperty(preferredUnit)) {
            return UNIT_MAPPINGS[preferredUnit];
        }

        return preferredUnit;
    }

    const onChange = (e) => {
        setSelectedParameter(e.target.value);
    };

    const groupedByCategory = parameters.reduce((acc, p) => {
        const catLabel = parameterPreferredUnits[p.standardName]?.category || "Other";
        (acc[catLabel] ||= []).push(p);
        return acc;
    }, {});

    // sort each group's parameters alphabetically by displayName
    Object.keys(groupedByCategory).forEach((cat) => {
        groupedByCategory[cat].sort((a, b) =>
            a.displayName.localeCompare(b.displayName, undefined, {
                numeric: true,
                sensitivity: "base",
            })
        );
    });

    return (
        <Select
            placeholder='Choose a Parameter...'
            size='md'
            background='white'
            width='100%'
            maxWidth={400}
            mx='auto'
            onChange={onChange}
            value={selectedParameter}
        >
            {Object.values(categories)
      .filter((label) => groupedByCategory[label]?.length)
      .map((label) => (
        <optgroup key={label} label={label}>
          {groupedByCategory[label].map((parameter) => (
            <option value={parameter.standardName} key={parameter.standardName}>
              {parameter.displayName}
              {getDropdownParamUnits(parameter) && <> ({getDropdownParamUnits(parameter)})</>}
            </option>
          ))}
        </optgroup>
      ))}
        </Select>
    );
};

export default ParameterSelect;
